import type { FC, ReactNode } from 'react'

interface HeroSectionProps {
    title: string
}

const HeroSection: FC<HeroSectionProps> = ({ title }): ReactNode => {
    return (
        <section
            id='hero'
            className='relative isolate flex min-h-svh items-center justify-center overflow-hidden bg-background px-6'
        >
            <div
                aria-hidden='true'
                className='pointer-events-none absolute inset-0 -z-10 m-auto size-[min(110vw,46rem)] animate-hero-glow motion-reduce:animate-none'
            >
                <div className='absolute left-0 top-[6%] size-[74%] bg-[radial-gradient(closest-side,var(--accent),transparent)]' />
                <div className='absolute bottom-[4%] right-0 size-[62%] bg-[radial-gradient(closest-side,var(--primary),transparent)] opacity-30' />
            </div>

            <h1 className='font-heading text-[clamp(7rem,28vw,20rem)] italic leading-none tracking-tight text-foreground animate-in fade-in slide-in-from-bottom-6 duration-1000 ease-out motion-reduce:animate-none'>
                {title}
            </h1>
        </section>
    )
}

export default HeroSection
